import React, { useMemo, useState } from 'react';

import { Collapse } from 'antd';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import BookingEventSingleModelName from '@components/EventDrawer/BookingEvent/EventDatesAndModels/BookingEventSingleModelName';
//import EventModelActions from '@components/EventDrawer/EventDrawerUi/EventModelActions';
//import { BookingEventSingleModelNameContainer } from '@components/EventDrawer/EventDrawerUi/EventUI';
//import OptionNumber from '@components/EventDrawer/EventDrawerUi/OptionNumber';
import FlexContainer from '@components/Gui/FlexContainer';
import NwIcon from '@components/Gui/NwIcon';

import { getModelNames } from './eventDatesAndModelsUtils';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const { Panel } = Collapse;

const StyledCollapse = styled(Collapse)`
    .ant-collapse-arrow {
        margin-right: 0 !important;
    }
`;

const CollapseHandle = styled(FlexContainer)`
    cursor: pointer;
    margin-top: 8px;
`;

const CollapsibleModels = ({
    models,
    eventData,
    expanded,
    eventDateInfo,
    currentModel,
    reloadGroupedModels,
    onExtendOptionNumberToAllDates,
    afterUpdate,
}) => {
    const [isExpanded, setIsExpanded] = useState(expanded || false);

    // const renderSingleModel = (model, withMarginTop = false) => {
    //     return (
    //         <BookingEventSingleModelName
    //             model={model}
    //             withPadding={false}
    //             withMarginTop={withMarginTop}
    //             currentModel={currentModel}
    //             eventData={eventData}
    //             eventDateInfo={eventDateInfo}
    //             reloadGroupedModels={reloadGroupedModels}
    //             onExtendOptionNumberToAllDates={onExtendOptionNumberToAllDates}
    //             afterUpdate={afterUpdate}
    //             onReloadEventStatus={onReloadEventStatus}
    //         />
    //     );
    // };

    const handleCollapse = (event) => {
        event.stopPropagation();
        setIsExpanded(isExpanded ? null : '1');
    };

    const sortedModels = useMemo(() => {
        const sortedModels = [...models];
        sortedModels.sort((a, b) => {
            if (a.Cancel !== b.Cancel) {
                return a.Cancel ? 1 : -1;
            }
            if (a.Cancel && b.Cancel) {
                if (a.OptionNumber === 10 && b.OptionNumber !== 10) {
                    return -1;
                }
                if (a.OptionNumber !== 10 && b.OptionNumber === 10) {
                    return 1;
                }
            }
            if (a.OptionNumber === 10 && b.OptionNumber !== 10) {
                return -1;
            }
            if (a.OptionNumber !== 10 && b.OptionNumber === 10) {
                return 1;
            }
            return getContactName(a.ModelID).localeCompare(getContactName(b.ModelID));
        });
        return sortedModels;
    }, [models]);

    return (
        <StyledCollapse
            activeKey={isExpanded ? '1' : null}
            //onChange={() => setIsExpanded(isExpanded ? null : '1')}
            ghost
            showArrow={false}
            accordion={true}
            expandIcon={() => <div />}
            bordered={false}
            className="event-info-collapse"
        >
            <Panel
                header={
                    isExpanded ? (
                        <BookingEventSingleModelName
                            model={sortedModels[0]}
                            withPadding={false}
                            withMarginTop={false}
                            currentModel={sortedModels[0]}
                            eventData={eventData}
                            eventDateInfo={eventDateInfo}
                            reloadGroupedModels={reloadGroupedModels}
                            onExtendOptionNumberToAllDates={onExtendOptionNumberToAllDates}
                            afterUpdate={afterUpdate}
                            onReloadEventStatus={reloadGroupedModels}
                        />
                    ) : (
                        <CollapseHandle onClick={handleCollapse}>{getModelNames(sortedModels)}</CollapseHandle>
                    )
                }
                key="1"
            >
                {sortedModels.slice(1).map((model, index) => (
                    <BookingEventSingleModelName
                        key={model.ModelID}
                        model={model}
                        withPadding={false}
                        withMarginTop={true}
                        currentModel={model}
                        eventData={eventData}
                        eventDateInfo={eventDateInfo}
                        reloadGroupedModels={reloadGroupedModels}
                        onExtendOptionNumberToAllDates={onExtendOptionNumberToAllDates}
                        afterUpdate={afterUpdate}
                        onReloadEventStatus={reloadGroupedModels}
                    />
                ))}
                <CollapseHandle onClick={handleCollapse}>
                    <NwIcon icon={byPrefixAndName.fasl['chevron-up']} />
                    &nbsp;COLLAPSE LIST
                </CollapseHandle>
            </Panel>
        </StyledCollapse>
    );
};

export default CollapsibleModels;
